<template>
    <div>
        <v-btn icon color="error" @click="mostrarDialogo = true">
            <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-dialog v-model="mostrarDialogo" scrollable>
            <v-card>
                <v-card-title class="error white--text">
                    {{$t('titulo_modal')}}
                </v-card-title>
                <v-card-text>
                    <v-list>
                        <v-list-item v-for="(cod, index) in codigosOrdenados" :key="index">
                            <v-list-item-content>
                                <v-list-item-title>
                                  <span v-html="$t('error', [cod, errores[cod]])" />
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click="mostrarDialogo = false">
                        {{$t('cerrar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    export default {
        name: "BtnVerMuestreos",
        props: {
            errores: {type: Object, required: true},
        },
        computed: {
            codigosOrdenados() {
                if (!this.errores) return [];

                return Object.keys(this.errores).sort();
            }
        },
        data: () => ({
            mostrarDialogo: false,
        }),
        methods: {}
    }
</script>

<style scoped>

</style>

<!-- @formatter:off -->
<i18n>
    {
    "es": {
    "errores": "errores",
    "error": "<span class='font-weight-bold'>{0}</span>: {1}",
    "indicador": "Indicador",
    "titulo_modal": "Descripción de los errores",
    "cerrar": "Cerrar"
    }
    }
</i18n>
<!-- @formatter:on -->